// extracted by mini-css-extract-plugin
module.exports = {"total":"invoicerecapitulationcard_total__2wYNl"};